export default "__VITE_ASSET__669179bb__"